import { request, gql } from 'graphql-request'
import { BAR_CLIENT } from 'config/constants/endpoints'
import { useEffect, useState } from 'react'
import { BarHistoryResponse } from '../types'

const fetchBarHistoryData = async (timestamp: number): Promise<{ data: BarHistoryResponse; error?: boolean }> => {
  try {
    const query = gql`
      query barDailySnapshots($startTime: Int) {
        barDailySnapshots(first: 1000, where: { date_gte: $startTime }) {
          date
          ratio
          vvsBalance
          totalSupply
          xVVSMinted
        }
      }
    `
    const historiesDatas = await request<BarHistoryResponse>(BAR_CLIENT, query, {
      startTime: timestamp,
    })
    const data = historiesDatas
    return { data, error: false }
  } catch (error) {
    console.error('Failed to fetch VVSBar histories data', error)
    return { data: { barDailySnapshots: [] }, error: true }
  }
}

export const useFetchVVSBarHistory = (timestamp: number): { data: BarHistoryResponse; error?: boolean } => {
  const [barHistory, setBarHostory] = useState<BarHistoryResponse | undefined>()
  const [error, setError] = useState(false)

  useEffect(() => {
    const fetch = async () => {
      const { data } = await fetchBarHistoryData(timestamp)
      if (data) {
        setBarHostory(data)
      } else {
        setError(true)
      }
    }
    if (!error) {
      fetch()
    }
  }, [timestamp, error])

  return {
    error,
    data: barHistory,
  }
}

export default fetchBarHistoryData
